export const tokens = {
  basicRewardAddress: "0x55555555a687343c6ce28c8e1f6641dc71659fad",
  rewardTokens: [
    {
      token: "XY",
      address: "0x55555555a687343c6ce28c8e1f6641dc71659fad",
      decimals: 18,
      coingeckoId: "xy-finance",
      rewardPerSecond: 0,
    },
    {
      token: "RBW",
      address: "0x431cd3c9ac9fc73644bf68bf5691f4b83f9e104f",
      decimals: 18,
      coingeckoId: "rainbow-token-2",
      rewardPerSecond: 0,
    },
  ],
};
